// Meta browser cookies (_fbp / _fbc) set by the Facebook Pixel. They are
// forwarded with the lead payload so the server side (Meta CAPI) can match
// the conversion back to the same browser session.
function readCookie(name: string): string {
  if (typeof document === 'undefined') return ''
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`),
  )
  return match ? decodeURIComponent(match[1]) : ''
}

export function getMetaCookies(): { fbp: string; fbc: string } {
  return {
    fbp: readCookie('_fbp'),
    fbc: readCookie('_fbc'),
  }
}

// `sub3` is the transport for Meta's match keys: the server splits it on "_"
// and reads [fbc, fbp] to send the conversion to the Conversions API.
// Neither cookie contains an underscore, so the join is unambiguous.
//
// When no Meta cookies are present (non-Meta traffic), whatever sub3 the URL
// supplied is passed through unchanged.
export function resolveSub3(search: string): string {
  const { fbp, fbc } = getMetaCookies()
  if (fbp || fbc) return `${fbc}_${fbp}`
  return new URLSearchParams(search).get('sub3') || ''
}
